import { ROUTES } from "@/lib/routes";

/**
 * The code of each page behind a link in the header, loaded once. The router
 * loads a page through these, and a link loads its page when the pointer
 * is over it, so the click finds it ready. Jobs, the home page, is not
 * here: it is in the first bundle (App.tsx), so the first visit draws it
 * without a second round of requests.
 */
export const PAGE_LOADERS = {
    [ROUTES.OVERVIEW]: () => import("@/pages/Overview"),
    [ROUTES.ENVOY]: () => import("@/pages/Envoy"),
    [ROUTES.SAVED]: () => import("@/pages/Saved"),
    [ROUTES.OPENINGS]: () => import("@/pages/Openings"),
    [ROUTES.APPLICATIONS]: () => import("@/pages/Queue"),
    [ROUTES.QUEUE]: () => import("@/pages/Queue"),
    [ROUTES.HISTORY]: () => import("@/pages/History"),
    [ROUTES.RESUME]: () => import("@/pages/Resume"),
    [ROUTES.ACCOUNT]: () => import("@/pages/Account"),
    [ROUTES.PRICING]: () => import("@/pages/Pricing"),
} as const;

/** Starts loading the page at `path`, if it is one of those above. A failure is left to the router. */
export function preloadPage(path: string): void {
    const load = (PAGE_LOADERS as Record<string, (() => Promise<unknown>) | undefined>)[path];
    load?.().catch(() => undefined);
}

/** The posting page's component, once `preloadPostingDetail` has it. */
export let PreloadedPostingDetail:
    Awaited<typeof import("@/pages/PostingDetail")>["default"] | null = null;

/**
 * Has a posting's code here before the server's page of it hydrates. `lazy` waits a turn on
 * its first render even when the code has arrived, and the sign-in or the saved cache can
 * answer in that turn. React then gives up on the server's markup and draws it again.
 */
export async function preloadPostingDetail(): Promise<void> {
    PreloadedPostingDetail = (await import("@/pages/PostingDetail")).default;
}

/** The check page's component, once `preloadResumeCheck` has it. */
export let PreloadedResumeCheck: Awaited<typeof import("@/pages/ResumeCheck")>["default"] | null =
    null;

/** Has a check page's code here before the server's page of it hydrates, as a posting's has. */
export async function preloadResumeCheck(): Promise<void> {
    PreloadedResumeCheck = (await import("@/pages/ResumeCheck")).default;
}
